import { RowContextMenuUI } from '../../../../../../view/design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../../view/design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';
import { IRiskManagerTemplateModel } from '../../../../service/manager/template/IRiskManagerTemplateModel';

export class RiskManagerTemplateContextMenuUI<RowType> extends RowContextMenuUI<IRiskManagerTemplateModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
